<template>
    <v-main>
      <CampaignsHero />
      <CampaignsFeatures/>
      <CampaignsTwoWay/>
      <CampaignsSurveys/>
      <CampaignsWorkflows/>
      <RequestDemo msg="See how Yabbr Campaigns can supercharge your customer engagement."/>
    </v-main>
</template>
  
<script>
import CampaignsHero from './CampaignsHero.vue'
import CampaignsFeatures from './CampaignsFeatures.vue'
import CampaignsTwoWay from './CampaignsTwoWay.vue'
import CampaignsSurveys from './CampaignsSurveys.vue'
import CampaignsWorkflows from './CampaignsWorkflows.vue'
import RequestDemo from './RequestDemo.vue'
export default {
  name: 'CampaignsPage',
  components: {
    CampaignsHero,
    CampaignsFeatures,
    CampaignsTwoWay,
    CampaignsSurveys,
    CampaignsWorkflows,
    RequestDemo
  },
}
</script>
  